import React, { useState } from "react";
import clsx from 'clsx';
import { Link } from "react-router-dom"
import { useSelector } from "react-redux";
import customStyles from "../../../assets/styles/customStyles";
import { Row, Col, Dropdown, Menu, Image } from "antd";
import { productMenus, inventoryDisableMenus } from "../../../config/constant";
import { checkPermission } from '../../../helpers/utilities';
import DropDownIcon from "../../../assets/images/icon_menus/Drop Down.svg";
import { ProductAnalysis, ProductGroupAnalysis, TopProductsSupply, StockValueReport, TransferValueReport, NetOrderReport } from "../../Shared/components/ReportEnquiry";

const Menus = (props) => {
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const [productAnalysisVisible, setProductAnalysisVisible] = useState(false);
    const [productGroupAnalysisVisible, setProductGroupAnalysisVisible] = useState(false);
    const [topProductsSupplyVisible, setTopProductsSupplyVisible] = useState(false);
    const [stockValueVisible, setStockValueVisible] = useState(false);
    const [transferValueVisible, setTransferValueVisible] = useState(false);
    const [netOrderVisible, setNetOrderVisible] = useState(false);
    const [menuTitle, setMenuTitle] = useState('');
    const classes = customStyles();
    const { menuHeight } = props;

    const handleMenuOnClick = (name) => {
        setMenuTitle(name);
        if (name === 'Product-wise Analysis') {
            setProductAnalysisVisible(true);
        } else if (name === 'Product Group wise Analysis') {
            setProductGroupAnalysisVisible(true);
        } else if (name === 'Top Products Supply') {
            setTopProductsSupplyVisible(true);
        } else if (name === 'Stock Value Report') {
            setStockValueVisible(true);
        } else if (name === 'Transfer Value Report') {
            setTransferValueVisible(true);
        } else if (name === 'Net Order Report') {
            setNetOrderVisible(true);
        }
    }
    return (
        <div className={clsx(classes.primaryPaper, classes.primaryMenu)} style={{ height: 'calc(100% - ' + menuHeight + 'px)', overflow: "auto" }}>
            <div style={{ height: '100%', overflow: "hidden" }}>
                <Row gutter={16}>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{productMenus.sub[0].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {
                                    productMenus.sub[0].sub.map((menus, i) => (
                                        <React.Fragment key={`${menus.menu}_${i}`}>
                                            {
                                                checkPermission(menus.menu, 'Product') &&
                                                <div key={i} className={clsx({ [classes.displayInventoryNone]: !parameterDetails?.inventoryTransaction && inventoryDisableMenus.includes(menus.menu) }, classes.margin10t, 'menuCheck')}>
                                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                </div>
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{productMenus.sub[1].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {
                                    productMenus.sub[1].sub.map((menus, i) => (
                                        <React.Fragment key={`${menus.menu}_${i}`}>
                                            {
                                                checkPermission(menus.menu, 'Product') &&
                                                <div key={i} className={clsx({ [classes.displayInventoryNone]: !parameterDetails?.inventoryTransaction && inventoryDisableMenus.includes(menus.menu) }, classes.margin10t, 'menuCheck')}>
                                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                </div>
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{productMenus.sub[2].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {productMenus.sub[2].sub.map((menus, i) => (
                                    <React.Fragment key={`${menus.menu}_${i}`}>
                                        {
                                            checkPermission(menus.menu, 'Product') && <>
                                                {
                                                    menus.onClick ? <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                                        <Link to={menus.link} onClick={() => handleMenuOnClick(menus.menu)} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                    </div> : <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                                        <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{productMenus.sub[3].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {
                                    productMenus.sub[3].sub.map((menus, i) => (
                                        <React.Fragment key={`${menus.menu}_${i}`}>
                                            {menus.menu === 'Units' ?
                                                <Dropdown
                                                    key={i}
                                                    className={clsx(classes.margin10t)}
                                                    overlay={
                                                        <Menu className={clsx(classes.addressDropdown)}>
                                                            {menus.sub.map(submenu => {
                                                                return (
                                                                    checkPermission(submenu.menu, 'Product') && <Menu.Item className={clsx(classes.color, classes.bold, 'menuCheck')} key={submenu.menu}>
                                                                        <Link to={submenu.link} className={clsx(classes.color, classes.bold)}>{submenu.menu}
                                                                        </Link>
                                                                    </Menu.Item>
                                                                )
                                                            })}
                                                        </Menu>
                                                    }>
                                                    <div>
                                                        <Link to={menus.link} className={clsx(classes.color, classes.bold, classes.PaddingRight10)}>{menus.menu}
                                                        </Link>
                                                        <Image
                                                            src={DropDownIcon}
                                                            preview={false}
                                                        />
                                                    </div>
                                                </Dropdown>
                                                : <React.Fragment key={`${menus.menu}_${i}`}>
                                                    {
                                                        checkPermission(menus.menu, 'Product') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <ProductAnalysis
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={productAnalysisVisible}
                    onProductAnalysisVisible={(v) => setProductAnalysisVisible(v)} />
                <ProductGroupAnalysis
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={productGroupAnalysisVisible}
                    onProductAnalysisVisible={(v) => setProductGroupAnalysisVisible(v)} />
                <TopProductsSupply
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={topProductsSupplyVisible}
                    onProductAnalysisVisible={(v) => setTopProductsSupplyVisible(v)} />
                <StockValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={stockValueVisible}
                    onStockValueVisible={(v) => setStockValueVisible(v)} />
                <TransferValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={transferValueVisible}
                    onTransferValueVisible={(v) => setTransferValueVisible(v)} />
                <NetOrderReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={netOrderVisible}
                    onNetOrderVisible={(v) => setNetOrderVisible(v)} />
            </div>
        </div>
    )
}

export default Menus